import type { ReactElement, SVGProps } from 'react'

export function TypeMarkMorpho(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      xmlns={'http://www.w3.org/2000/svg'}
      width={'104'}
      height={'21'}
      viewBox={'0 0 104 21'}
      fill={'currentColor'}
      {...props}
    >
      <path
        d={
          'M2.53223 13.5905V19.4119C2.53223 19.7702 2.83552 19.919 2.92987 19.9528C3.02423 19.9934 3.34099 20.0813 3.62405 19.8176L8.02794 15.5854C8.40298 15.2251 8.76493 14.8463 9.03693 14.403C9.16496 14.1947 9.21802 14.0773 9.21802 14.0773C9.48764 13.5296 9.48764 13.0023 9.22469 12.4749C8.83394 11.6906 7.83638 10.8928 6.33337 10.1355L3.76559 11.5689C3.00402 12.0016 2.53223 12.7656 2.53223 13.5905Z'
        }
        fill={'#004EC3'}
      />
      <path
        d={
          'M0 0.642806V6.74819C0 7.5122 0.512226 8.18831 1.24012 8.40467C3.72033 9.12136 8.04046 10.6629 9.08514 12.9279C9.21983 13.2254 9.30074 13.5162 9.32787 13.8204C10.022 12.5561 10.3388 11.1024 10.1905 9.62844C9.98823 7.53924 8.88286 5.63933 7.15759 4.42908L1.00423 0.122192C0.89638 0.0410568 0.768328 0.000488281 0.640278 0.000488281C0.53243 0.000488281 0.438076 0.0207726 0.336987 0.0748625C0.134785 0.189803 0 0.399404 0 0.642806Z'
        }
        fill={'#5792FF'}
      />
      <path
        d={
          'M18.9118 13.5905V19.4119C18.9118 19.7702 18.6086 19.919 18.5141 19.9528C18.4199 19.9934 18.1029 20.0813 17.82 19.8176L13.3135 15.487C13.0068 15.1922 12.7139 14.8804 12.4828 14.5231C12.2998 14.2403 12.226 14.0773 12.226 14.0773C11.9564 13.5296 11.9564 13.0023 12.2191 12.4749C12.6101 11.6906 13.6077 10.8928 15.1105 10.1355L17.6784 11.5689C18.4468 12.0016 18.9118 12.7656 18.9118 13.5905Z'
        }
        fill={'#004EC3'}
      />
      <path
        d={
          'M21.448 0.642318V6.74769C21.448 7.5117 20.9357 8.18782 20.2077 8.40418C17.7276 9.12086 13.4075 10.6624 12.3629 12.9274C12.2279 13.2249 12.147 13.5157 12.1201 13.8199C11.426 12.5556 11.1092 11.1019 11.2575 9.62797C11.4595 7.53874 12.5649 5.63886 14.2904 4.4286L20.4438 0.121701C20.5516 0.0405662 20.6796 0 20.8076 0C20.9154 0 21.0099 0.0202842 21.1108 0.0743741C21.3131 0.189315 21.448 0.398914 21.448 0.642318Z'
        }
        fill={'#5792FF'}
      />
      <path
        d={
          'M31.8874 1.96167H34.243L39.7025 14.5892H39.8643L45.3237 1.96167H47.6389V16.5202H45.9202V4.93404H45.7585L40.754 16.5202H38.7724L33.7679 4.93404H33.6061V16.5202H31.8874V1.96167Z'
        }
      />
      <path
        d={
          'M49.5373 11.3742C49.5373 7.8963 51.6503 5.97538 54.7844 5.97538C57.9084 5.97538 60.0316 7.8963 60.0316 11.3742C60.0316 14.8419 57.9084 16.7629 54.7844 16.7629C51.6503 16.7629 49.5373 14.8419 49.5373 11.3742ZM51.3369 11.3742C51.3369 13.9219 52.722 15.307 54.7844 15.307C56.8368 15.307 58.2219 13.9219 58.2219 11.3742C58.2219 8.81632 56.8368 7.44135 54.7844 7.44135C52.722 7.44135 51.3369 8.81632 51.3369 11.3742Z'
        }
      />
      <path
        d={
          'M61.7308 6.21803H63.4496V7.45146H63.6113C63.9652 6.72353 64.6122 6.17759 66.1591 6.17759H67.5947V7.71432H66.1995C64.2685 7.71432 63.5102 8.77588 63.5102 10.8687V16.5202H61.7308V6.21803Z'
        }
      />
      <path
        d={
          'M68.9635 20.5643V6.21803H70.7025V7.64355H70.8642C71.6326 6.45056 72.8862 5.98549 74.3421 5.98549C77.0213 5.98549 79.0736 7.80531 79.0736 11.3742C79.0736 14.9329 77.0213 16.7528 74.3421 16.7528C72.9166 16.7528 71.673 16.2978 70.9047 15.1554H70.7429V20.5643H68.9635ZM70.6822 11.3742C70.6822 13.8714 72.0168 15.2767 73.9781 15.2767C75.9496 15.2767 77.2841 13.8714 77.2841 11.3742C77.2841 8.86687 75.9496 7.46157 73.9781 7.46157C72.0168 7.46157 70.6822 8.86687 70.6822 11.3742Z'
        }
      />
      <path
        d={
          'M80.7773 1.96167H82.5567V7.4919H82.7185C83.4565 6.40001 84.6798 5.98549 86.1256 5.98549C88.5217 5.98549 90.0382 7.19871 90.0382 9.71612V16.5202H88.2588V9.88799C88.2588 8.20972 87.3388 7.47168 85.7313 7.47168C83.9721 7.47168 82.5567 8.51302 82.5567 10.7676V16.5202H80.7773V1.96167Z'
        }
      />
      <path
        d={
          'M91.6388 11.3742C91.6388 7.8963 93.7518 5.97538 96.8859 5.97538C100.01 5.97538 102.133 7.8963 102.133 11.3742C102.133 14.8419 100.01 16.7629 96.8859 16.7629C93.7518 16.7629 91.6388 14.8419 91.6388 11.3742ZM93.4384 11.3742C93.4384 13.9219 94.8234 15.307 96.8859 15.307C98.9383 15.307 100.323 13.9219 100.323 11.3742C100.323 8.81632 98.9383 7.44135 96.8859 7.44135C94.8234 7.44135 93.4384 8.81632 93.4384 11.3742Z'
        }
      />
    </svg>
  )
}
